import { Component, Input, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbProgressbar } from "@ng-bootstrap/ng-bootstrap/progressbar";

import { ApiService } from "src/app/api.service";
import { DvsUtilities, ADMIN_OPERATIONS_LIMIT } from "src/app/dvs-utilities";
import { FilesizePipe, DatetimePipe, RuntimePipe } from "src/app/pipes";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-asset-data",
	templateUrl: "./asset-data.component.html",
	styleUrls: ["./asset-data.component.scss"],
	imports: [FormsModule, ActionButtonComponent, NgbProgressbar, FilesizePipe, DatetimePipe, RuntimePipe]
})
export class AssetDataComponent implements OnInit {
	private api = inject(ApiService);
	readonly ADMIN_OPERATIONS_LIMIT = ADMIN_OPERATIONS_LIMIT;

	@Input()
	asset: APIResults.Asset;

	public GetOpClass = DvsUtilities.GetOpClass;

	public hiStatus: string;
	public hiProgress: number;

	public statesStatus: string;
	public statesProgress: number;

	public assetOps: APIResults.Operation[] = null;
	public selectedOperation: APIResults.Operation = null;
	public opDatafiles: APIResults.DataFile[];
	public datafilesLoading = false;

	async ngOnInit(): Promise<void> {
		this.hiProgress = undefined;
		this.hiStatus = undefined;

		this.statesProgress = undefined;
		this.statesStatus = undefined;

		await this.RefreshAssetOps();
	}

	private async RefreshAssetOps() {
		this.assetOps = undefined;
		this.assetOps = await this.api.GetOperations(this.asset.asset_id, ADMIN_OPERATIONS_LIMIT, true);
	}

	public async GetDatafiles() {
		try {
			this.datafilesLoading = true;
			this.opDatafiles = await this.api.GetOperationDatafiles(this.asset.asset_id, this.selectedOperation.operation_id);
		} finally {
			this.datafilesLoading = false;
		}
	}

	public async GenerateHIs() {
		const result = await this.api.GenerateHIs(this.asset.asset_id);
		const taskId = result.task;
		await this.api.PollTaskToCompletion(taskId, (status, progress) => {
			this.hiStatus = status;
			this.hiProgress = progress;
		});
	}

	public async RecalculateStates() {
		const result = await this.api.RecalculateAssetStates(this.asset.asset_id);
		const taskId = result.task;
		await this.api.PollTaskToCompletion(taskId, (status, progress) => {
			this.statesStatus = status;
			this.statesProgress = progress;
		});
	}
}
